import './aulaAdd.css'
import { useEffect, useState } from 'react'
import { BiX } from 'react-icons/bi'
import {addItem, getDocCollection,updateItem } from '../../../firebase/CRUD'
import { useAuth } from '../../../hooks/AuthContext'
import { useToast } from '../../../hooks/Toast'
import ContainerForm from '../../layout/Form/ContainerForm'
import Input from '../../layout/Input/Input'
import Button from '../../layout/Button/Button'
import { useNavigate } from 'react-router-dom'

export default function AulaAdd({cadastramento,edit}){
    const {usuario} = useAuth()
    const {mostrarAviso} = useToast()
    const [turmasID, setTurmasID] = useState([])
    // CORREÇÃO: estava `useState({})` (objeto), mas o código usa
    // `idsTurmas.map(...)` mais abaixo — se o usuário enviasse o
    // formulário antes da busca assíncrona (getDocCollection) responder,
    // `{}.map` quebrava com TypeError. Também não havia nenhuma trava
    // impedindo o envio nesse intervalo.
    const [idsTurmas, setIdsTurmas] = useState([])
    const [turmasCarregadas, setTurmasCarregadas] = useState(false)
    const [idsTurmasAulas,setIdsTurmasAulas] = useState([])
    const [carregando, setCarregando] = useState(false)
    const navigate = useNavigate()
    const [formData, setFormData] = useState(edit || {
        licao: '',
        dataAula: new Date(),
        observacao: '',
        turmas: [],
        situacao: 'aberta',
        biblia: 0,
        revista: 0,
        presencas: 0,
    })

    const handleInputChange = (e)=>{
        const {name, value} = e.target
        setFormData({
            ...formData,
            [name]:value
        })
    }
    
    useEffect(()=>{
        getDocCollection("turmas",(dados)=>{
            setIdsTurmas(dados)
            setTurmasCarregadas(true)
        },usuario.idEscola)
    },[])

    const turmaAula = async (dataAula)=>{
        let dt = {
            dia: Number(dataAula[8] + dataAula[9]),
            mes:Number(dataAula[5] + dataAula[6]),
            ano:Number(dataAula[2] + dataAula[3]),
            trimestre: parseInt((Number(dataAula[5] + dataAula[6])/3) + 0.67)
        }
        const criacaoFichas = idsTurmas.map((element) => {
           return addItem("aulaTurma",
                {
                    situacao: "aberta",
                    idTurma:element.id, 
                    nome:element.nome,
                    data: dt
                },
                usuario.idEscola
                )
        })
        
        const resposta = await Promise.all(criacaoFichas)
        return resposta
            
    }

    const finalizar = async (e)=>{
        e.preventDefault()
         if(edit){
            updateItem('aulas',edit.id,formData,usuario.idEscola)
            cadastramento()
            return
        }
        if(carregando)
            return
        // CORREÇÃO: garante que a lista de turmas já carregou antes de
        // permitir o envio — sem isso, um clique rápido demais no botão
        // "Salvar" rodava `idsTurmas.map(...)` com a lista ainda vazia
        // (ou, antes da correção acima, com um objeto {}), criando uma
        // aula sem nenhuma `aulaTurma` associada.
        if(!turmasCarregadas){
            mostrarAviso('Aguarde as turmas carregarem antes de salvar','erro')
            return
        }
        setCarregando(true)

        // CORREÇÃO: antes o modal fechava (cadastramento()) e o
        // addItem('aulas', ...) rodava sem await nem try/catch — se a
        // gravação falhasse, o usuário não ficava sabendo (o modal já
        // tinha sumido) e `setCarregando(false)` nunca era chamado nesse
        // caminho de erro.
        try {
            let ids = await turmaAula(formData.dataAula)
            formData.turmas = ids
            await addItem('aulas',formData,usuario.idEscola)
            cadastramento()
        } catch (error) {
            mostrarAviso('Erro ao salvar aula: ' + error.message,'erro')
        } finally {
            setCarregando(false)
        }
    }
    
    return(
        <ContainerForm cadastramento={cadastramento} finalizar={finalizar}>
            <Input 
                label={"Lição:"}
                name={"licao"}
                placeholder={"Digite o nome da lição ou nº da aula"}
                onChange={handleInputChange}
                value={formData.licao}
                required={true}
            />
            <Input 
                type='date'
                value={formData.dataAula}
                label={"Data"}
                onChange={handleInputChange}
                required={true}
                name={"dataAula"}
            />
            <Input 
                label={"Observação:"}
                name={"observacao"}
                placeholder={"Deixe aqui uma observação"}
                onChange={handleInputChange}
                value={formData.observacao}
                // required={true}
            />
            <Button type='submit'>
                Salvar aula
            </Button>
        </ContainerForm>
    )
}

{/*             
            {!edit && 
            <div 
                
                className={`${style.button}`}
                
               
                    
            >
                {
                    carregando ? (
                        <>
                        <span className={`${style.spinner}`}></span>
                            Salvando...
                        </>
                    ) : (<p>Salvar</p>)
                }   
            </div>
            }
            {edit && 
            <button type='button'
                className={`${style.button}`}
                
                onClick={()=>{
                    cadastramento()
                    updateItem(
                        "aulas",
                        edit.id,
                        attAula,
                    )}}
            >Atualizar</button>
            } */
           }